import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: '首页', href: '#home' },
    { label: '核心业务', href: '#business' },
    { label: 'AI产品', href: '#ai-products' },
    { label: '客户案例', href: '#cases' },
    { label: '新闻动态', href: '#news' },
    { label: '联系我们', href: '#contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img
              src="https://static.readdy.ai/image/335e3e62ea46a4ee8fffcd870552cca1/45145859d95338398b93e9f0fa2b0f33.png"
              alt="龙创未来"
              className={`h-8 lg:h-12 w-auto transition-all duration-300 ${scrolled ? '' : 'brightness-0 invert'}`}
            />
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`text-sm font-medium transition-colors duration-200 relative group whitespace-nowrap cursor-pointer ${
                  scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white/90 hover:text-white'
                }`}
              >
                {item.label}
                <span className={`absolute bottom-0 left-0 w-0 h-0.5 transition-all duration-200 group-hover:w-full ${
                  scrolled ? 'bg-teal-600' : 'bg-white'
                }`}></span>
              </a>
            ))}
          </div>

          {/* Right Side Actions */}
          <div className="hidden lg:flex items-center space-x-4">
            {/* Search Button */}
            <button
              onClick={() => setSearchOpen(!searchOpen)}
              className={`w-10 h-10 flex items-center justify-center transition-colors cursor-pointer ${
                scrolled ? 'text-gray-600 hover:text-teal-600' : 'text-white/90 hover:text-white'
              }`}
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl"></i>
            </button>

            {/* CTA Button */}
            <a
              href="#contact"
              className={`px-6 py-2.5 text-sm font-medium rounded-full transition-all duration-200 shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-gradient-to-r from-teal-500 to-teal-600 text-white hover:from-teal-600 hover:to-teal-700'
                  : 'border-2 border-white text-white hover:bg-white hover:text-gray-900'
              }`}
            >
              立即咨询
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${
              scrolled ? 'text-gray-700' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`text-2xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {/* Search Bar */}
        {searchOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg p-4 animate-slideDown">
            <div className="max-w-2xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="搜索..."
                  className="w-full px-4 py-3 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:border-teal-500 text-sm"
                  autoFocus
                />
                <button className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-teal-600 cursor-pointer">
                  <i className="ri-search-line text-xl"></i>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden bg-white border-t border-gray-200 overflow-hidden transition-all duration-300 ease-in-out ${
          mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 space-y-1">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="block text-gray-700 hover:text-teal-600 hover:bg-gray-50 text-sm font-medium py-3 px-3 rounded-lg cursor-pointer transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#contact"
            className="block text-center px-6 py-3 mt-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm font-medium rounded-full whitespace-nowrap cursor-pointer"
          >
            立即咨询
          </a>
        </div>
      </div>
    </nav>
  );
}